module.exports = __webpack_public_path__ + "img/CW.47012a76.svg";